var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSameYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 22,
    viewBox: "0 0 76 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 15L66 9.2265V20.7735L76 15ZM1.81559 21.5786L12.2061 6.93295L10.5749 5.77569L0.184409 20.4214L1.81559 21.5786ZM28.0374 4.69879L38.6471 13.1625L39.8944 11.5991L29.2846 3.13532L28.0374 4.69879ZM46.7541 16H67V14H46.7541V16ZM38.6471 13.1625C40.9499 14.9995 43.8083 16 46.7541 16V14C44.2615 14 41.8429 13.1535 39.8944 11.5991L38.6471 13.1625ZM12.2061 6.93295C15.8621 1.77967 23.098 0.758522 28.0374 4.69879L29.2846 3.13532C23.4472 -1.52136 14.8957 -0.314541 10.5749 5.77569L12.2061 6.93295Z",
    fill: "#FFD763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSameYellow);
export default __webpack_public_path__ + "static/media/same-yellow.60e2a3492e382c6da62dc69308c02ed0.svg";
export { ForwardRef as ReactComponent };